/* eslint-disable import/prefer-default-export */
import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";

export const useAttackMechanisms = (projectId, config = {}) => {
  return ReactQuery.useQuery({
    ...config,
    queryKey: ["attackMechansims", projectId],
    queryFn: () => Brm.attackMechanismApi.findAttackMechanism(projectId),
  });
};
